import { TIME_ZONES } from 'components/views/call-center/details/hours-form/timezones';
import { CompanyCallCenter_company_callCenters } from 'types/apollo/CompanyCallCenter';

type HoursRange = { from: string; to: string };

export function getCallCenterSummaryText(callCenter: CompanyCallCenter_company_callCenters | null) {
  let text = '';
  if (callCenter) {
    const timezone = TIME_ZONES[callCenter.timezone];

    if (callCenter.alwaysOpen) {
      return `Always open (${timezone})`;
    }

    const { mon, tue, wed, thu, fri, sat, sun } = callCenter.hours;

    const monMatchTue = compareDays(mon, tue);
    const monMatchWed = compareDays(mon, wed);
    const monMatchThu = compareDays(mon, thu);
    const monMatchFri = compareDays(mon, fri);

    if (monMatchTue && monMatchWed && monMatchThu && monMatchFri) {
      text += `${getDayTimeText(mon, 'Mon-Fri')},`;
    } else {
      text +=
        `${getDayTimeText(mon, 'Mon')}, ${getDayTimeText(tue, 'Tue')}, ` +
        `${getDayTimeText(wed, 'Wed')}, ${getDayTimeText(thu, 'Thu')}, ${getDayTimeText(
          fri,
          'Fri',
        )},`;
    }
    if (compareDays(sat, sun)) {
      text += ` ${getDayTimeText(sat, 'Sat & Sun')}`;
    } else {
      text += ` ${getDayTimeText(sat, 'Sat')}, ${getDayTimeText(sun, 'Sun')}`;
    }
    text += ` (${timezone})`;
  }
  return text;
}

function getDayTimeText(day: HoursRange | null, daysSuffix: string) {
  if (day) {
    return `${formatTime(day.from)}-${formatTime(day.to)} ${daysSuffix}`;
  }
  return `closed ${daysSuffix}`;
}

export function formatTime(time: string) {
  const [hour, minutes] = time.split(':');
  const minutesFormatted = !minutes || minutes == '00' ? '' : `:${minutes}`;

  const numberedHours = Number(hour);
  if (numberedHours == 24 || numberedHours == 0) {
    return `12${minutesFormatted}am`;
  } else if (numberedHours > 12) {
    return `${numberedHours - 12}${minutesFormatted}pm`;
  } else if (numberedHours == 12) {
    return `${numberedHours}${minutesFormatted}pm`;
  }
  return `${numberedHours}${minutesFormatted}am`;
}

function compareDays(day1: HoursRange | null, day2: HoursRange | null) {
  return day1?.to === day2?.to && day1?.from === day2?.from;
}
